import React from 'react';
import { photoSrc } from '../Api/Profileapi';
import LinkIcon from './LinkIcon';
import { applyCustomization } from '../Data/templates';
import '../Style/Templates.css';

function initials(name) {
  if (!name) return '?';
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join('');
}

/**
 * Draws one template with the user's saved profile and links inside it.
 * Everything scales with the width of its container, so the same component
 * works for small grid cards and the large preview.
 */
export default function TemplatePreview({ template, profile, customization, live = false, decorative = false }) {
  const { style: s, iconStyle } = applyCustomization(template, customization || {});
  const p = profile || {};
  const name = p.full_name || 'Your Name';
  const socials = p.socials || [];
  const links = (p.links || []).filter((l) => l.is_active !== false).slice(0, 6);

  const src = photoSrc(p.photo_url);

  const vars = {
    '--t-bg': s.bg,
    '--t-fg': s.fg,
    '--t-muted': s.muted,
    '--t-font': s.font,
    '--t-banner': s.banner,
    '--t-card': s.card,
    '--t-btn-bg': s.btnBg,
    '--t-btn-fg': s.btnFg,
    '--t-btn-border': s.btnBorder,
    '--t-btn-radius': s.btnRadius,
    '--t-btn-shadow': s.btnShadow,
    '--t-icon-bg': s.iconBg,
    '--t-icon-fg': s.iconFg,
    '--t-ring': s.ring,
    '--t-accent': s.accent,
    '--t-accent-fg': s.accentFg,
    '--t-brand': s.brand,
    '--t-bg-image': s.bgImageUrl ? `url(${photoSrc(s.bgImageUrl)})` : 'none',
    '--t-bg-overlay': typeof s.bgOverlay === 'number' ? s.bgOverlay / 100 : 0,
  };

  return (
    <div
      className="tpl"
      data-layout={s.layout}
      data-avatar={s.avatar}
      data-links={s.linkLayout}
      data-name-style={s.nameStyle}
      data-iconstyle={iconStyle}
      data-hasbg={s.bgImageUrl ? 'true' : undefined}
      style={vars}
      aria-hidden={decorative ? 'true' : undefined}
    >
      <div className="tpl__screen">
        {s.layout === 'banner' && <div className="tpl__banner" />}

        <div className="tpl__body">
          <div className="tpl__avatar">
            {src ? <img src={src} alt={decorative ? '' : name} /> : <span>{initials(name)}</span>}
          </div>

          <p className="tpl__name">{name}</p>
          {p.username && <p className="tpl__user">@{p.username}</p>}
          {p.bio && <p className="tpl__bio">{p.bio}</p>}
          {p.location && <p className="tpl__loc">{p.location}</p>}

                   {links.length > 0 && (
            <div className="tpl__links">
              {links.map((l) => {
                const content = (
                  <>
                    <span className="tpl__btn-icon">
                      <LinkIcon icon={l.icon} width="1.1em" height="1.1em" />
                    </span>
                    <span className="tpl__btn-label">{l.label}</span>
                  </>
                );
                return live && l.url ? (
                  <a key={l.id || l.label} className="tpl__btn" href={l.url} target="_blank" rel="noopener noreferrer">
                    {content}
                  </a>
                ) : (
                  <div className="tpl__btn" key={l.id || l.label}>
                    {content}
                  </div>
                );
              })}
            </div>
          )}

                    {socials.length > 0 && (
            <div className="tpl__icons">
              {socials.map((x, i) => {
                const iconEl = (
                  <LinkIcon icon={x.platform === 'other' ? 'other' : x.platform} width="1.25em" height="1.25em" />
                );
                return live ? (
                  <a key={`${x.platform}-${i}`} className="tpl__icon" href={x.url} target="_blank" rel="noopener noreferrer">
                    {iconEl}
                  </a>
                ) : (
                  <span className="tpl__icon" key={`${x.platform}-${i}`}>
                    {iconEl}
                  </span>
                );
              })}
            </div>
          )}
        </div>

        <p className="tpl__brand">mlink.com/{p.username || 'yourname'}</p>
      </div>
    </div>
  );
}